import { Especialidade } from "../../especialidade/especialidade";

export class ProcedimentoConsulta {

    id: number = 0;

    especialidade: Especialidade = new Especialidade();

    nome: string = '';

    tipoAgendamento: string = '';

    disponivel: boolean = false;

    valor: number = 0.00;

    apelido: string = '';

    observacao: string = '';

    selecionado: boolean = false;

    cobrarProcedimento: boolean = false;

    tipoAgendamentoFormatado: string = '';

    disponivelFormatado: string = '';

    constructor() {
    }
}
